import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getCurrentBetCashedOutPrice } from '../../../openBets/selectors';

const CongratulationsOnline = ({ value }) => (
  <div className="congratulations">
    <h2 className="congratulations__header">Congratulations!</h2>
    <div className="congratulations__info">
      You cashed in this bet for £{value}! The funds have automatically
      been credited to your online account, please allow 24hrs for
      this to show on any statements.
    </div>
  </div>
);

CongratulationsOnline.propTypes = {
  value: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  value: getCurrentBetCashedOutPrice(state)
});

export default connect(mapStateToProps)(CongratulationsOnline);
